import { render } from "./Category.vue?vue&type=template&id=43a60a8e&scoped=true"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"

import "./Category.vue?vue&type=style&index=0&id=43a60a8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a60a8e"]])

export default __exports__